import { takeEvery } from '@zaibot/fsa-saga';
import { fork, put } from '../redux-saga';
import { useridResource } from './resource';
import AUTHENTICATED from '../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../auth/actions/LOGGEDOUT';
import USER_ID_LOADED from './actions/USER_ID_LOADED';
import USER_ID_NOT_LOADED from './actions/USER_ID_NOT_LOADED';

export function* rootSaga(): Iterable<any> {
    yield fork(useridResource.saga);
    yield fork(signalUserLoad);
    yield fork(signalUserLoaded);
    yield fork(signalUserNotLoaded);
    yield fork(signalParticipantReset);
}

function* signalUserLoad() {
    yield takeEvery(AUTHENTICATED, function*() {
         yield put(useridResource.actions.LIST({}));
        
    });
}

function* signalUserLoaded() {
    yield takeEvery(
        useridResource.actions.LIST_SUCCESS, function*(action) {
        var participantid=
            action.payload.list&&action.payload.list.length>0?
            action.payload.list[0].id:
            '';
            
        yield put(USER_ID_LOADED({id: participantid}));
    });
}

function* signalUserNotLoaded() {
    yield takeEvery(
        useridResource.actions.LIST_FAILURE, function*() {        
        yield put(USER_ID_NOT_LOADED({}));
    });
}

function* signalParticipantReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(useridResource.actions.RESET({ }));
    }); 
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/participantid/sagas.tsx